export const UNLOCK_WITH_POINTS_MODAL_TEXT = {
  AVAILABLE_BALANCE: 'Available Balance:',
  POINTS_AVAILABLE_BADGE: 'Points Available',
  NEED_MORE_POINTS_BADGE_PREFIX: 'Need ',
  NEED_MORE_POINTS_BADGE_SUFFIX: ' more Points',
  GET_MORE_CTA_PREFIX: 'GET ',
  GET_MORE_CTA_MIDDLE: ' MORE POINTS & UNLOCK',
  UNLOCK_WITH_PREFIX: 'UNLOCK WITH ',
  UNLOCK_WITH_SUFFIX: ' POINTS',
  COST_POINTS_SUFFIX: ' Points',
  BALANCE_POINTS_SUFFIX: ' Points',
  COIN_ALT: 'Points coin',
  DEFAULT_HEADER: 'Unlock with Points',
  PRIMARY_BTN_NAME_UNLOCK: 'unlockWithPoints',
  PRIMARY_BTN_NAME_GET_MORE: 'getMorePoints',
  UNABLE_TO_START_UNLOCK: 'Unable to start unlock.',
  UNABLE_TO_START_CHECKOUT: 'Unable to start checkout.'
} as const;
